import { List as ImmutableList } from 'immutable';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import { useCallback, useMemo } from 'react';
// @ts-expect-error Untyped import
import { Sort } from 'reporting-data/config/sort';
import { NONE } from 'reporting-data/constants/chartTypes';
import { DESC } from 'reporting-data/constants/sortOrder';
import { getDataType, getSort } from 'reporting-data/report/configReportGetters';
import { getDefaultSortForDimensionProp, getSortPropertyValueFromConfigReport } from '../utils';
import { setSort } from 'reporting-data/report/configReportSetters';
import ConfigReportSortDirectionDropdown from './ConfigReportSortDirectionDropdown';
import useFetchSortablePropertyOptionsForDropdown from './useFetchSortablePropertyOptionsForDropdown';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getSortNoneOption = () => ({
  value: NONE,
  text: I18n.text('report-customization-components.customization-components.sort-selector-dropdown.config.options.none')
});
const ConfigReportSortSelectorDropdown = ({
  report,
  onChange
}) => {
  const sortableDropdownOptionsFromReport = useFetchSortablePropertyOptionsForDropdown(report);
  const sortSelectorOptions = useMemo(() => {
    return [getSortNoneOption()].concat(sortableDropdownOptionsFromReport);
  }, [sortableDropdownOptionsFromReport]);
  const sortPropertyValue = useMemo(() => {
    return getSortPropertyValueFromConfigReport(report);
  }, [report]);
  const reportHasSort = useMemo(() => {
    var _getSort;
    return !!((_getSort = getSort(report)) !== null && _getSort !== void 0 && _getSort.first());
  }, [report]);
  const onChangeSortProperty = useCallback(({
    target: {
      value
    }
  }) => {
    var _getSort2;
    const sort = (_getSort2 = getSort(report)) === null || _getSort2 === void 0 ? void 0 : _getSort2.first();
    const order = sort ? sort.get('order') : DESC;
    const [metric, property] = value.includes('|') ? value.split('|') : [undefined, value];
    const newSort = value !== NONE && Sort(metric ? {
      property,
      type: 'METRIC',
      metricType: metric,
      order
    } : Object.assign({}, getDefaultSortForDimensionProp(property, getDataType(report)), {
      order
    }));
    onChange(value !== NONE ? setSort(report, ImmutableList([newSort])) : setSort(report, ImmutableList([])));
  }, [report, onChange]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "report-customization-components.customization-components.sort-selector-dropdown.config.label"
      }),
      children: /*#__PURE__*/_jsx(Select, {
        options: sortSelectorOptions,
        onChange: onChangeSortProperty,
        value: sortPropertyValue
      })
    }), reportHasSort && /*#__PURE__*/_jsx(ConfigReportSortDirectionDropdown, {
      report: report,
      onChange: onChange
    })]
  });
};
export default ConfigReportSortSelectorDropdown;